<button class="mat-button" [ngClass]="classes"
        [attr.aria-disabled]="disabled || loading"
        [disabled]="disabled || loading"
        (click)="onClick($event)"
        [type]="style === buttonStyle.PRIMARY ? 'submit' : 'button'"
        [style.--primary-color]="primaryColor">
    <txp-loading [color]="color" [type]="loadingType.INLINE"></txp-loading>
    <i class="icon" *ngIf="icon" (click)="onClick($event)" [ngClass]="icon"></i>
	<ng-content></ng-content>
</button>
